module.exports = __webpack_public_path__ + "img/icon.0c59abc8.png";